import { BlogInterface } from 'modules/blogs/types/blog-interface'
import { BlogPagesInterface } from 'modules/blogs/types/blog-pages-interface'

export const getBlogPageUrl = (blog: BlogInterface | undefined, page: BlogPagesInterface) =>
  `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${blog?.domain.domainName}${
    blog?.path !== '' ? `/${blog?.path}` : ''
  }${page.path !== '' ? `/${page.path}` : ''}`
